import script from "./ConversationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationCard.vue?vue&type=script&setup=true&lang=js"

import "./ConversationCard.vue?vue&type=style&index=0&id=6e1a51be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1a51be"]])

export default __exports__